import { useQuery } from 'react-query'
import { serviceProviderByEmail } from '../../../utils/badaAppointmentApi'

const useServiceProviderByEmail = (selectedStore, selectedServiceProviderEmail) =>
    useQuery(
      ['serviceProviderByEmail', selectedServiceProviderEmail],
      () => serviceProviderByEmail(selectedStore, selectedServiceProviderEmail),
      { enabled: !!selectedStore && selectedServiceProviderEmail !== null }
    )

export default useServiceProviderByEmail